import { render, staticRenderFns } from "./DramaToolbar.vue?vue&type=template&id=1cf6d7b0&scoped=true"
import script from "./DramaToolbar.vue?vue&type=script&lang=js"
export * from "./DramaToolbar.vue?vue&type=script&lang=js"
import style0 from "./DramaToolbar.vue?vue&type=style&index=0&id=1cf6d7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf6d7b0",
  null
  
)

export default component.exports